module.exports = __webpack_public_path__ + "account/assets/higher.83839ff5.svg";